import { addMinutes, addHours, addDays, isBefore } from 'date-fns'
import { IS_PRODUCTION } from '@/libs/constants'
import httpClient from '@/libs/http-client'

console.warn(`API URL: ${baseUrl()}`)
console.warn(`VAEX URL: ${vaexBaseUrl()}`)

let cacheSet = {}

export function baseUrl () {
  let baseUrl = 'http://localhost:5000'

  if (process.env.VUE_APP_API_BASE_URL) {
    baseUrl = process.env.VUE_APP_API_BASE_URL
  } else if (IS_PRODUCTION) {
    baseUrl = 'https://staging-api.beusable.net'
  }

  return baseUrl
}

export function vaexBaseUrl () {
  let vaexBaseUrl = 'http://localhost:5500'

  if (process.env.VUE_APP_VAEX_BASE_URL) {
    vaexBaseUrl = process.env.VUE_APP_VAEX_BASE_URL
  } else if (IS_PRODUCTION) {
    vaexBaseUrl = 'https://vaex-api.beusable.net'
  }

  return vaexBaseUrl
}

export function solomonBaseUrl () {
  let solomonBaseUrl = 'https://staging-solomon-api.beusable.net'

  if (process.env.VUE_APP_SOLOMON_BASE_URL) {
    solomonBaseUrl = process.env.VUE_APP_SOLOMON_BASE_URL
  } else if (IS_PRODUCTION) {
    solomonBaseUrl = 'https://solomon-api.beusable.net'
  }

  return solomonBaseUrl
}

export function apiHubBaseUrl () {
  let apiHubBaseUrl = 'https://staging-api-hub.beusable.net'

  if (process.env.VUE_APP_API_HUB_BASE_URL) {
    apiHubBaseUrl = process.env.VUE_APP_API_HUB_BASE_URL
  } else if (IS_PRODUCTION) {
    apiHubBaseUrl = 'https://api-hub.beusable.net'
  }

  return apiHubBaseUrl
}

export function isApiUrl (url) {
  return isBeusableApiUrl(url) || isVaexApiUrl(url) || isApiHubApiUrl(url)
}

export function isBeusableApiUrl (url) {
  return url.charAt(0) === '/' || url.indexOf(baseUrl()) === 0
}

export function isApiHubApiUrl (url) {
  return url.indexOf(apiHubBaseUrl()) === 0
}

export function isVaexApiUrl (url) {
  return url.indexOf(vaexBaseUrl()) === 0
}

function getObjectKey (obj) {
  const key = Object.entries(obj).map(([key, value]) => {
    return `${key}=${value}`
  }).join('&')
  return key
}

function getCacheKey (config) {
  const method = config.method || 'get'
  const cacheKeys = [method, config.url]

  if (config.params) {
    cacheKeys.push(getObjectKey(config.params))
  }
  if (config.data) {
    cacheKeys.push(getObjectKey(config.data))
  }
  const key = cacheKeys.join('|')
  return key
}

function getTtlDate (ttl) {
  const ttlRegex = /^\d+[mMhHdD]$/

  if (!ttlRegex.test(ttl)) {
    console.error(`invalid ttl: ${ttl}`)
    return null
  }
  const now = new Date()
  const value = parseInt(ttl, 10)
  const unit = ttl.charAt(ttl.length - 1).toLowerCase()

  switch (unit) {
    case 'm':
      return addMinutes(now, -value)
    case 'h':
      return addHours(now, -value)
    case 'd':
      return addDays(now, -value)
    default:
      return null
  }
}

function setCache (key, data) {
  cacheSet[key] = {
    data,
    date: new Date()
  }
}

function getCache (key, ttl) {
  const cache = cacheSet[key]
  const ttlDate = getTtlDate(ttl)

  if (cache) {
    if (isBefore(cache.date, ttlDate)) {
      delete cacheSet[key]
    } else {
      return cache.data
    }
  }
  return null
}

export function clearAllApiCache () {
  cacheSet = {}
}

export function request (config, force = false, ttl = '3m') {
  const isApiRequest = isApiUrl(config.url)

  if (!isApiRequest) {
    return httpClient(config)
  }

  const key = getCacheKey(config)

  if (!force && ttl) {
    const cache = getCache(key, ttl)

    if (cache) {
      cache.cache = true
      return Promise.resolve(cache)
    }
  }

  return httpClient(config).then(response => {
    const data = response.data.result
    setCache(key, Array.isArray(response.data.result) ? [ ...response.data.result ] : { ...response.data.result })
    if (data && typeof data === 'object' && config.method !== 'get') {
      data['cache'] = false
    }
    return data
  })
}
